"use client";

import { ReactNode } from "react";
import Link from "next/link";
import { gtmOpenEventVenue } from "~/lib/client/gtm";
import { PlainMessage } from "@bufbuild/protobuf";
import { EventDetails } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";

type Props = {
  details: PlainMessage<EventDetails>;
  url: string;
};

export default function MapsLink({ url, details }: Props): ReactNode {
  return (
    <Link
      prefetch={false}
      className="hover:underline"
      title="Google Maps Venue Link"
      aria-label="Google Maps Venue Link"
      target="_blank"
      href={url}
      rel="noreferrer"
      onClick={() => {
        gtmOpenEventVenue(details);
      }}
    >
      <p className="text-left text-[24px] font-semibold">
        {details.venue?.name}
      </p>
    </Link>
  );
}
